/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

/** 2.サイズと回転 */
export const template2 = {
  title: t.to('サイズと回転', 'title2'),
  desc: t.to(
    'サイズ属性を使うと物体の大きさを変えられます。x:横幅、y:高さ、z:奥行きのそれぞれの方向への倍率を指定します。小さくするには小数で入力します。回転属性は、x軸、y軸、z軸のそれぞれに対して何度回転させるかを指定します',
    'desc2'
  ),
  img: '../public/template/2.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <block type="a-scene-start" x="110" y="110">
    <statement name="IN">
      <block type="sphere_v2">
        <field name="id">block1</field>
        <field name="position-x">1</field>
        <field name="position-y">1.5</field>
        <field name="position-z">2.5</field>
        <value name="COLOUR">
          <shadow type="color_value_v2">
            <field name="COLOUR">#ff0000</field>
          </shadow>
        </value>
        <value name="ATTR">
          <block type="scale_v2">
            <field name="scale-x">0.5</field>
            <field name="scale-y">0.5</field>
            <field name="scale-z">0.5</field>
          </block>
        </value>
        <next>
          <block type="cube_v2">
            <field name="id">block2</field>
            <field name="position-x">0</field>
            <field name="position-y">1.5</field>
            <field name="position-z">0</field>
            <value name="COLOUR">
              <shadow type="color_value_v2">
                <field name="COLOUR">#ffd100</field>
              </shadow>
            </value>
            <value name="ATTR">
              <block type="scale_v2">
                <field name="scale-x">3</field>
                <field name="scale-y">3</field>
                <field name="scale-z">3</field>
                <value name="ATTR">
                  <block type="rotation_v2">
                    <field name="rotation-x">360</field>
                    <field name="rotation-y">45</field>
                    <field name="rotation-z">360</field>
                  </block>
                </value>
              </block>
            </value>
            <next>
              <block type="cube_v2">
                <field name="id">block3</field>
                <field name="position-x">-1</field>
                <field name="position-y">1.5</field>
                <field name="position-z">2</field>
                <value name="COLOUR">
                  <shadow type="color_value_v2">
                    <field name="COLOUR">#1800ff</field>
                  </shadow>
                </value>
                <next>
                  <block type="environment_v2">
                    <field name="preset">forest</field>
                  </block>
                </next>
              </block>
            </next>
          </block>
        </next>
      </block>
    </statement>
  </block>
</xml>
`,
};
